const Joi = require("joi");
const ValidationTranslateFile = require("../Loc/ValidationTranslateFile.jsx");
const currentLang = ValidationTranslateFile()

const Send_ECardsSchema = (data) => {

    const schema = Joi.object({
        user: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Please_select_user,
                "any.required": currentLang?.ValidationSchema?.Please_select_user,
            }),
        subject: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": currentLang?.ValidationSchema?.Please_Enter_Subject,
                "any.required": currentLang?.ValidationSchema?.Please_Enter_Subject,
            }),

    }).unknown(true);

    return schema.validate(data, {
        abortEarly: false,
    });
};

module.exports = Send_ECardsSchema;
